module.exports = {"insurerHandoverButton":{"componentName":"HandoverButton"},"insurerHandoverPage":{"componentName":"InsurerHandoverPage"}}